import { useMemo } from 'react';
import { AnimatePresence, m as motion } from 'framer-motion';
import { jsx as _jsx } from "react/jsx-runtime";
const parentHeightDuration = {
  default: 0.2,
  tall: 0.3
};
const childFadeOutDuration = {
  default: 0.15,
  tall: 0.2
};
const getMotionConfig = variant => ({
  parent: {
    enter: {
      height: 'auto',
      transition: {
        type: 'tween',
        duration: parentHeightDuration[variant],
        when: 'beforeChildren'
      },
      transitionEnd: {
        display: 'block'
      }
    },
    exit: {
      height: 0,
      transition: {
        type: 'tween',
        duration: parentHeightDuration[variant],
        when: 'afterChildren'
      },
      transitionEnd: {
        display: 'none'
      }
    }
  },
  child: {
    enter: {
      opacity: 1,
      transition: {
        type: 'tween',
        duration: 0.3
      }
    },
    exit: {
      opacity: 0,
      transition: {
        type: 'tween',
        duration: childFadeOutDuration[variant]
      }
    }
  }
});
const AnimatedPresence = _ref => {
  let {
    children,
    isExpanded,
    motionConfig,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(AnimatePresence, {
    initial: false,
    children: isExpanded && /*#__PURE__*/_jsx(motion.div, {
      ...props,
      animate: "enter",
      exit: "exit",
      initial: "exit",
      variants: motionConfig.parent,
      children: /*#__PURE__*/_jsx(motion.div, {
        variants: motionConfig.child,
        children: children
      })
    })
  });
};
const AnimatedVisibility = _ref2 => {
  let {
    children,
    'data-testid': dataTestId,
    isExpanded,
    motionConfig,
    ...props
  } = _ref2;
  return /*#__PURE__*/_jsx(motion.div, {
    animate: isExpanded ? 'enter' : 'exit',
    exit: "exit",
    hidden: !isExpanded,
    initial: false,
    variants: motionConfig.parent,
    ...props,
    children: /*#__PURE__*/_jsx(motion.div, {
      "data-testid": `footerAccordionContent-${dataTestId}`,
      initial: false,
      variants: motionConfig.child,
      children: children
    })
  });
};
const ExpandableContent = _ref3 => {
  let {
    children,
    'data-testid': dataTestid,
    isExpanded,
    shouldUnmountOnExit = true,
    variant = 'default',
    ...props
  } = _ref3;
  const motionConfig = useMemo(() => getMotionConfig(variant), [variant]);
  const Wrapper = shouldUnmountOnExit ? AnimatedPresence : AnimatedVisibility;
  return /*#__PURE__*/_jsx(Wrapper, {
    ...props,
    "data-testid": dataTestid,
    isExpanded: isExpanded,
    motionConfig: motionConfig,
    children: children
  });
};
export default ExpandableContent;